import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import variables from "../../../constants/assets/variables";
import VerifyDriverDocumentsDetailsFields from "../../../constants/DeliveryDrivers/VerifyDriverDocumentsFields.json";
import DriverProfileImageFields from "../../../constants/DeliveryDrivers/DriverProfileImageFields.json";
import { connect } from "react-redux";
import { getPath } from "../../../utils";
import DirectUpload from "./DirectUpload";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import { setStatus } from "../../../store/actions/User";
import { useParams } from "react-router-dom";
import {
  validateDriverDocuments,
  validateRequiredDriverDocuments,
} from "./validations";
import ErrorModal from "../../Common/ErrorModal";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import commonStyles from "../../../static/styles/common";
import DriverDocumentModal from "../../Common/DriverDocumentModal";
import {
  FieldsContainer,
  FieldsSection,
} from "../../../constants/assets/ScrollableContainer";
import Image from "material-ui-image";
import Checkbox from "sushiweb/InputTypes/Checkbox";

const useStyles = makeStyles((_theme) => commonStyles.fileUploadButton);

export const requiredDocsForDocVerify = ["pan_card_doc", "image"];

const VerifyDriverDocument = ({
  action,
  documents,
  allMenuActions,
  editState,
  saveState,
  setSaveState,
  setStatus,
  updateDriverDocumentsDetails,
  handleAfterSave,
  onChange,
  getDriverDocuments,
  uploadingFiles,
  setUploadingFiles,
  setTriggerDirectUpload,
  triggerDirectUpload,
  errors,
  setErrors,
  driverBasicDetails,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [pdf, setPdf] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [formDisabled, setFormDisabled] = useState(false);
  const [acknowledged, setAcknowledged] = useState(false);
  const [documentDetailTemplate] = useState(
    action == "upload_profile_image"
      ? DriverProfileImageFields
      : VerifyDriverDocumentsDetailsFields
  );

  const acknowledgeLabel = () => {
    return action == "upload_profile_image"
      ? "I confirm that I have verified the profile image and found it valid."
      : "I confirm that I have verified all the documents and found them valid.";
  };

  const requiredDocs = () => {
    return action == "upload_profile_image"
      ? ["image"]
      : requiredDocsForDocVerify;
  };

  const params = useParams();
  const classes = useStyles();

  const attachFile = (id, file) => {
    setUploadingFiles({
      ...uploadingFiles,
      [id]: { id: id, file: file },
    });
    console.log(uploadingFiles, "uploading-files");
  };

  const shouldDirectUpload = (id) => {
    return (
      triggerDirectUpload && uploadingFiles[id] && !uploadingFiles[id].uploaded
    );
  };

  const directUploadFile = (id) => {
    return uploadingFiles[id].file;
  };

  const handleErrorModalSubmit = () => {
    setErrors([]);
  };

  const isFilePresent = (documents, path) => getPath(documents, path, false);

  const getField = (type, field) => {
    switch (type) {
      case "image": {
        var file_present = isFilePresent(
          documents,
          `${field.key}.expiring_url`
        );
        if (!file_present && !field.allowUpload) {
          return handleNonUploadDocNotPresent(field.placeholder);
        }
        if (
          !file_present &&
          getPath(field, "uploadPermission", false) &&
          !allMenuActions[field.uploadPermission]
        ) {
          return handleUploadNotAllowed(field.placeholder);
        }

        return !file_present ? (
          <div>
            <React.Fragment>
              <Button
                variant="outlined"
                style={{ position: "relative" }}
                component="span"
                disabled={formDisabled}
                className={classes.uploadButton}
              >
                {`upload`}
                <input
                  type="file"
                  style={{ opacity: 0, position: "absolute" }}
                  id={field.id}
                  multiple
                  onChange={(e) =>
                    attachFile(field.id, e.currentTarget.files[0])
                  }
                />
              </Button>
              <p className={`${classes.fileName} mt-10`}>
                {getPath(uploadingFiles, `${field.id}.file.name`, false) ||
                  getPath(documents, `${field.key}.file_name`, false)}
              </p>
            </React.Fragment>

            {shouldDirectUpload(field.id) && (
              <DirectUpload
                driverId={params.id}
                type={field.id}
                directUploadFile={directUploadFile(field.id)}
                onUploadSuccess={(signed_id) => {
                  handleDirectUploadSuccess(field.id, signed_id);
                }}
                handleDirectUploadFailure={(error) =>
                  handleDirectUploadFailure(field.id, error)
                }
              />
            )}
          </div>
        ) : (
          <DocumentHolder>
            {file_present &&
            documents[field.key]?.file_name.endsWith(".pdf") ? (
              <span
                onClick={() =>
                  handleDocClick(
                    documents[field.key].expiring_url,
                    documents[field.key].file_name
                  )
                }
                className="driverDoc"
              >
                {"View"}
              </span>
            ) : (
              ""
            )}
          </DocumentHolder>
        );
      }
      default:
        return "";
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setPdf("");
  };

  const handleDirectUploadSuccess = (id, signed_id) => {
    let oldFileData = uploadingFiles[id];
    setUploadingFiles({
      ...uploadingFiles,
      [id]: {
        id: id,
        file: oldFileData.file,
        document_type: id,
        uploaded: true,
        attachment: signed_id,
      },
    });
  };

  const handleDirectUploadFailure = (id, error) => {
    setStatus({
      type: "error",
      message: `${id} was not uploaded, error: ${error}. Please retry`,
    });
    setSaveState(false);
    setFormDisabled(false);
  };

  const handleNonUploadDocNotPresent = (name) => {
    const message = `${name} not found, Please refresh the page`;
    setSaveState(false);
    return (
      <div>
        <React.Fragment>
          <p> {message}</p>
        </React.Fragment>
      </div>
    );
  };

  const handleUploadNotAllowed = (name) => {
    const message = `You are not allowed to upload ${name}`;
    setSaveState(false);
    return (
      <div>
        <React.Fragment>
          <p> {message}</p>
        </React.Fragment>
      </div>
    );
  };

  const handleUpload = () => {
    let err = [];
    err = validateDriverDocuments(uploadingFiles);
    setErrors(err);
    if (err.length > 0) {
      setSaveState(false);
      setAcknowledged(false);
      onChange(true);
    } else {
      setTriggerDirectUpload(true);
    }
  };

  useEffect(() => {
    saveState && handleUpload();
  }, [saveState]);

  useEffect(() => {
    setUploadingFiles({});
  }, [editState]);

  const handleDocClick = (url, fileName) => {
    setShowModal(true);
    if (fileName.includes("pdf")) {
      setPdf(url);
    } else {
      setModalContent(url);
    }
  };

  const handleChange = (value) => {
    const err = validateRequiredDriverDocuments(
      documents,
      uploadingFiles,
      driverBasicDetails,
      requiredDocs()
    );
    setErrors(err);
    if (err.length > 0) {
      setSaveState(false);
    } else {
      setAcknowledged(value);
      onChange(!value);
      handleUpload();
    }
  };

  const isMandatory = (field) => {
    return field?.isMandatory;
  };

  return [
    <DriverDocumentsDetailsContainer>
      <FieldsContainer>
        {documentDetailTemplate.sections.map((section, index) => {
          return (
            <FieldsSection key={index}>
              {section.name && <p>{section.name}</p>}
              <FieldsContainer>
                {section.fields.map((field, fieldIdx) => {
                  return (
                    <React.Fragment>
                      <FieldHolder
                        key={fieldIdx}
                        noBorder={field.noBorder}
                        justify="flex-start"
                        className="mb-20"
                      >
                        {field.placeholder && (
                          <span className="flex items-center flex-start">
                            <b>{field.placeholder}</b>
                            {isMandatory(field) && <sup>*</sup>}
                          </span>
                        )}
                        {field.permissions
                          ? allMenuActions[field.permissions]
                            ? getField(field.type, field)
                            : ""
                          : getField(field.type, field)}
                      </FieldHolder>

                      {isFilePresent(
                        documents,
                        `${field.key}.expiring_url`
                      ) && (
                        <Image
                          src={documents[field.key]?.expiring_url}
                          onClick={() =>
                            handleDocClick(
                              documents[field.key]?.expiring_url,
                              documents[field.key]?.file_name
                            )
                          }
                          aspectRatio={16 / 9}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
                <Checkbox
                  value="verify"
                  checked={acknowledged}
                  onChange={(e) => handleChange(e.verify)}
                  className="sushi-checkbox mt-20"
                  label={acknowledgeLabel()}
                />
              </FieldsContainer>
            </FieldsSection>
          );
        })}
      </FieldsContainer>
      {errors.length > 0 && (
        <ErrorModal
          handleSubmit={handleErrorModalSubmit}
          heading="Error while saving"
          errors={errors}
        />
      )}
    </DriverDocumentsDetailsContainer>,
    <DriverDocumentModal
      showModal={showModal}
      handleClose={handleClose}
      pdf={pdf}
      modalContent={modalContent}
    />,
  ];
};

const DriverDocumentsDetailsContainer = styled(DriverBasicDetailsContainer)`
  .document-info {
    font-size: 0.8rem;
    span {
      color: ${variables.blue500};
    }
  }
  a {
    text-align: right;
    display: block;
  }
`;

const DocumentHolder = styled.div`
  .driverDoc {
    color: ${variables.primaryColor};
    cursor: pointer;
    text-decoration: underline;
  }
`;

function mapStateToProps(state) {
  const { MenuActions, DeliveryDrivers } = state;

  return {
    allMenuActions: MenuActions.allMenuActions,
    driverBasicDetails: DeliveryDrivers.driverBasicDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateDriverDocumentsDetails: bindActionCreators(
      DeliveryDriversActions.updateDriverDocuments,
      dispatch
    ),
    getDriverDocuments: bindActionCreators(
      DeliveryDriversActions.getDriverDocuments,
      dispatch
    ),
    setStatus: bindActionCreators(setStatus, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyDriverDocument);
